export const mappingAutomationTypeWithField = {
  "abandoned-cart": "abandonedCartCampaign",
  "just-abandoned-checkout": "abandonedCartCampaign",
  "back-in-stock": "backInStockCampaign",
  "order-confirmation": "orderConfirmationCampaign",
  "order-tracking": "orderTrackingCampaign",
  "optin-confirmation": "optinConfirmationCampaign",
};
